<template>
  <div class="vld-parent" v-show="lastPayment" ref="lastPayment">
    <span>
      {{ lastPayment }}
    </span>
  </div>
</template>

<script>
import { mapState } from 'pinia'
import { useStore } from '../stores/store'

import { RestApi } from '../services/service'
import { config } from '../settings'

let rest = new RestApi()

export default {
  name: 'LastPaymentLoader',
  props: {
    LoanID: String
  },
  data() {
    return {
      lastPayment: '-'
    }
  },
  computed: {
    ...mapState(useStore, ['ClientID'])
  },
  methods: {},
  mounted() {
    const request = {
      data: { ClientID: this.ClientID },
      url: rest._constructURL(config.urls.getClientPayments)
    }

    const loader = this.$loading.show(
      Object.assign({}, this.$loaderProps, {
        'is-full-page': false,
        container: this.$refs.lastPayment,
        width: 40,
        height: 40,
        loader: 'dots',
        'enforce-focus': false,
        blur: '0'
      })
    )

    rest
      ._request(request)
      .then((response) => {
        try {
          for (let payment of response.data.History) {
            if (payment.LoanID === this.LoanID) {
              this.lastPayment = this.$helpers.formatDate(
                new Date(payment.Date),
                'DD.MM.YYYY'
              )
            }
          }
        } catch (e) {
          console.log(e)
        }
      })
      .catch((error) => {
        console.log(error)
      })
      .then(() => {
        loader.hide()
      })
  }
}
</script>

<style scoped lang="scss"></style>
